/**
 * Created by mac on 6/22/20
 */

const TileGenerator = function () {
    this._index = -1;
    this._cache = [];
};

TileGenerator.prototype.reset = function (tiles, maxColors) {
    this._cache = PseudoRandom.GET().shuffle(this.listTiles(tiles, maxColors));
    this._index = -1;
};

TileGenerator.prototype.getAvailableSkins = function (colors) {
    const requiredForLevel = Math.max(colors, TileGenerator.INIT_TILES + cleverapps.meta.selectedLocationId() * TileGenerator.OPEN_PER_SIMPLE_STAGE);
    const availableSkins = TileGenerator.getExistingSkins();

    let skins = availableSkins.default;

    if (cleverapps.gameModes.replaceTiles) {
        skins = PseudoRandom.GET().shuffle(availableSkins.event).concat(availableSkins.default);
        skins = skins.slice(0, requiredForLevel);
        return skins;
    }

    const availableOnLevel = Math.min(requiredForLevel, skins.length);

    let openedSkins = skins.splice(0, availableOnLevel);

    const newSkins = TileGenerator.getNewSkins();
    openedSkins = openedSkins.slice(0, openedSkins.length - newSkins.length);
    openedSkins = PseudoRandom.GET().shuffle(openedSkins);

    return newSkins.concat(openedSkins);
};

TileGenerator.prototype.listTiles = function (tiles, maxColors) {
    const cache = [];

    const skins = this.getAvailableSkins(maxColors);

    const existingAmounts = [];
    for (let j = 0; j < 100; j++) {
        existingAmounts.push(0);
    }
    tiles.forEach((data) => {
        if (data.value !== undefined) {
            existingAmounts[data.value]++;
        }
    });

    let random = tiles.filter((data) => data.value === undefined).length;

    for (let j = 0; j < existingAmounts.length; j++) {
        if (existingAmounts[j] % 3 !== 0) {
            const remaining = 3 - (existingAmounts[j] % 3);
            for (let t = 0; t < remaining && random > 0; t++) {
                random--;
                cache.push(j);
            }
        }
    }

    for (let i = 0; i < random; i++) {
        const block = Math.floor(i / 3);
        const colorNumber = block % maxColors;
        cache.push((skins[colorNumber]));
    }

    return cache;
};

TileGenerator.prototype.next = function () {
    this._index++;
    if (this._index === this._cache.length) {
        this._index = 0;
    }
    return this._cache[this._index];
};

TileGenerator.prototype.clear = function () {
    delete this._cache;
};

TileGenerator.getExistingSkins = function () {
    const skins = { default: [] };
    let currSkin = 0;

    while (bundles.card.frames[`skin_${currSkin}`]) {
        skins.default.push(currSkin);
        currSkin++;
    }

    if (cleverapps.gameModes.replaceTiles) {
        skins.event = [];
        currSkin = 0;
        while (bundles.card.frames[`skin_event_${currSkin}`]) {
            skins.event.push(`event_${currSkin}`);
            currSkin++;
        }
    }

    return skins;
};

TileGenerator.getNewSkins = function (isRandom) {
    const existingSkins = TileGenerator.getExistingSkins().default;
    const newSkins = [];

    const location = cleverapps.meta.getSelectedLocation();
    let openedTiles = TileGenerator.INIT_TILES + TileGenerator.OPEN_PER_SIMPLE_STAGE * (location.getStage() - 1);

    if (isRandom) {
        openedTiles = Math.round(Math.random() * (existingSkins.length - TileGenerator.OPEN_PER_SIMPLE_STAGE));
    }

    for (let index = 0; index < TileGenerator.OPEN_PER_SIMPLE_STAGE; index++) {
        if (openedTiles + index < existingSkins.length) {
            newSkins.push(existingSkins[openedTiles + index]);
        }
    }

    return newSkins;
};

TileGenerator.INIT_TILES = 8;
TileGenerator.OPEN_PER_SIMPLE_STAGE = 2;